/**
 * The form sections of the generator, in display order. Built in Phase 1 to
 * be flipped per phase: Phase 3 unlocks the taxonomy decision chain
 * (`taxonomy: true` sections are driven by taxonomy/index.js). The
 * remaining sections stay locked with the phase that will enable them —
 * the page layout never changes.
 */

export const SECTIONS = [
  { id: 'documentType', label: 'Document Type', enabled: true, phase: 1 },
  { id: 'industry', label: 'Industry', enabled: true, phase: 3, taxonomy: true },
  { id: 'category', label: 'Category', enabled: true, phase: 3, taxonomy: true },
  { id: 'purpose', label: 'Purpose', enabled: true, phase: 3, taxonomy: true },
  { id: 'audience', label: 'Audience', enabled: true, phase: 3, taxonomy: true },
  { id: 'brandPersonality', label: 'Brand Personality', enabled: true, phase: 3, taxonomy: true },
  { id: 'visualTheme', label: 'Visual Theme', enabled: true, phase: 3, taxonomy: true },
  { id: 'layoutStyle', label: 'Layout Style', enabled: true, phase: 3, taxonomy: true },
  { id: 'imageStyle', label: 'Image Style', enabled: true, phase: 3, taxonomy: true },
  { id: 'colorMood', label: 'Color Mood', enabled: true, phase: 3, taxonomy: true },
  { id: 'typographyStyle', label: 'Typography Style', enabled: true, phase: 3, taxonomy: true },
  { id: 'region', label: 'Region', enabled: true, phase: 4 },
  { id: 'language', label: 'Language', enabled: true, phase: 4 },

  // Brand identity — free-form, so these carry a `kind`. Everything without
  // one is a select, which is what every field above is.
  { id: 'campaignTitle', label: 'Campaign Title', enabled: true, phase: 4, kind: 'text', placeholder: 'Summer Smile Offer' },
  { id: 'brandName', label: 'Brand Name', enabled: true, phase: 4, kind: 'text', placeholder: 'Brightline Family Dental' },
  { id: 'logo', label: 'Logo', enabled: true, phase: 4, kind: 'upload' },
  { id: 'brandColors', label: 'Brand Colors', enabled: true, phase: 4, kind: 'colors' },
  { id: 'contactDetails', label: 'Contact Details', enabled: true, phase: 4, kind: 'contact' },

  { id: 'batchSize', label: 'Batch Size', enabled: true, phase: 5 },
  { id: 'quality', label: 'Quality', enabled: true, phase: 5 },
  { id: 'variation', label: 'Variation', enabled: true, phase: 5 },
  { id: 'images', label: 'Images', enabled: true, phase: 5 },
];
